// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import "./polyfill";
import Vue from "vue";
import BootstrapVue from "bootstrap-vue";
import VTooltip from 'v-tooltip';

import App from "./App.vue";
import store from "./store/index";
import router from "./router/index";
import clientTableSettins from "@/_helpers/_clientTableSettins"; //If i delete it clientTable will not work
import Notifications from "vue-notification";
import DatePicker from 'vue2-datepicker';
import '@/assets/css/VueDatepicker.css';

import "./vee-validate";

import axios from "axios";
import VueAxios from "vue-axios";

import Paginate from "vuejs-paginate";
Vue.component("paginate", Paginate);

import moment from "moment";
Vue.prototype.$moment = moment;

import vSelect from 'vue-select'
import 'vue-select/dist/vue-select.css';
Vue.component('v-select', vSelect)

Vue.use(VueAxios, axios);
Vue.use(BootstrapVue);
Vue.use(Notifications);
Vue.use(DatePicker);
Vue.use(VTooltip);

import vueDebounce from 'vue-debounce'
Vue.use(vueDebounce)

import "@/assets/css/style.css";

Vue.config.productionTip = false;

//INIT GLOBAL PARAMS
//Possible values id, code
Vue.prototype.DISPLAY_PRODUCT_ID = 'code';


/* eslint-disable no-new */
new Vue({
    render: h => h(App),
    store,
    router,
    components: { App }
}).$mount("#app");
